import { render } from "./ConnectWalletModal.vue?vue&type=template&id=5e625749&scoped=true"
import script from "./ConnectWalletModal.vue?vue&type=script&lang=js"
export * from "./ConnectWalletModal.vue?vue&type=script&lang=js"

import "@/Common/Styles/commonModal.scss?vue&type=style&index=0&id=5e625749&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e625749"]])

export default __exports__